// Folder keys are generated UI IDs. Only leaf file IDs may be sent for authorization.
export function collectResourceFileUuids(nodes = []) {
    return [...new Set(nodes.flatMap(node => node.type === "file"
        ? [node.key]
        : collectResourceFileUuids(node.children || [])))];
}
